export default {
  en: {
    audiomic: {
      selectmic: "Select microphone",
      nomicavailable: "No microphone available",
      micpermissiondenied: "Microphone access is denied",
    }
  },
  de: {
    audiomic: {
      selectmic: "Mikrofon auswählen",
      nomicavailable: "Kein Mikrofon verfügbar",
      micpermissiondenied: "Mikrofonzugriff verweigert",
    }
  },
  es: {
    audiomic: {
      selectmic: "Seleccionar micrófono",
      nomicavailable: "No hay micrófono disponible",
      micpermissiondenied: "El acceso al micrófono está denegado",
    }
  },
  uk: {
    audiomic: {
      selectmic: "Вибрати мікрофон",
      nomicavailable: "Мікрофон недоступний",
      micpermissiondenied: "Доступ до мікрофона заборонено",
    }
  }
}
